
import { Sidebar } from "@/components/ui/sidebar";
import { FilteredSidebarMenu } from "./sidebar/FilteredSidebarMenu";
import { AppSidebarHeader } from "./sidebar/SidebarHeader";

export function AppSidebar() {
  return (
    <Sidebar 
      side="right" 
      variant="sidebar"
      collapsible="icon"
      className="border-l border-border/40 bg-background/95 backdrop-blur-md shadow-xl transition-all duration-300"
      dir="rtl"
    >
      <div className="flex flex-col h-full relative bg-background">
        {/* خلفية متدرجة خفيفة */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/3 via-transparent to-purple-500/3 pointer-events-none"></div>
        
        <AppSidebarHeader />
        <FilteredSidebarMenu />
        
        {/* شريط سفلي أنيق */}
        <div className="relative mt-auto p-4 border-t border-border/50 bg-background">
          <div className="flex items-center gap-2 text-xs text-muted-foreground z-10 relative">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse shadow-glow-primary"></div>
            <span className="font-medium">النظام نشط</span>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}
